import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import {Link} from "react-router-dom";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import 'datatables.net-fixedcolumns';
import {css} from "@emotion/core";
import * as moment from "moment";
import {connect}  from  "react-redux";
import loadingGif from "../../assets/img/loading.gif";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient, user_activities } from '../../helpers/utils.js';
import MultiCsvReportDownload from '../DownloadReport/MultiCsvReportDownload.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import AsoMultiFilter from '../../filters/AsoMultiFilter.jsx';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('0', '0', '2020-02-01','0');
var BeatPlanDetailReportTable='';

class BeatPlanDetailReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            ciutidIds: '',
            loading:false,
            isChange: false,
            object_code:[],
            state_code:"",
            tableHeaders:[],
            tableBody:[],
            aso_names:"",
            download_limit:31,
            uid:'',
            isAiQcExpanded: false,
            isActionListExpanded: false
        }
        this.toggleAiQcDetail = this.toggleAiQcDetail.bind(this);
        this.toggleActionList = this.toggleActionList.bind(this);
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");


        //isReportAccess(AllAccessPermissions, 'GRD_dump_report');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });


    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.isAiQcExpanded !== this.state.isAiQcExpanded || prevState.isActionListExpanded !== this.state.isActionListExpanded) {
            this.updateColumnVisibility();
        }
    }
    updateColumnVisibility() {
        if (BeatPlanDetailReportTable) {
            BeatPlanDetailReportTable.column(6).visible(!this.state.isAiQcExpanded);

            const detailedIndices = [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
            detailedIndices.forEach(index => {
                BeatPlanDetailReportTable.column(index).visible(this.state.isAiQcExpanded);
            });

            BeatPlanDetailReportTable.column(60).visible(!this.state.isActionListExpanded);

            const actionListIndices = [61, 62, 63, 64, 65, 66];
            actionListIndices.forEach(index => {
                BeatPlanDetailReportTable.column(index).visible(this.state.isActionListExpanded);
            });
            
            const displayValue = (this.state.isAiQcExpanded || this.state.isActionListExpanded) ? '' : 'none';
            $('#BeatPlanDetailReportTable thead tr:nth-child(2)').css('display', displayValue);
            $('#BeatPlanDetailReportTable thead tr:nth-child(3)').css('display', displayValue);
            $('.dataTables_scrollHead thead tr:nth-child(2)').css('display', displayValue);
            $('.dataTables_scrollHead thead tr:nth-child(3)').css('display', displayValue);
            
            BeatPlanDetailReportTable.columns.adjust();
        }
    }
    toggleAiQcDetail() {
        this.setState(prevState => ({
            isAiQcExpanded: !prevState.isAiQcExpanded
        }));
    }
    toggleActionList() {
        this.setState(prevState => ({
            isActionListExpanded: !prevState.isActionListExpanded
        }));
    }
    componentDidMount() {
        //this.get_download_limit();
        const params = new URLSearchParams(this.props.location.search);

        const beatplan_date = decodeURIComponent(params.get('beatplan_date') || '');
        const aso_employeecode = decodeURIComponent(params.get('aso_employeecode') || '');
        const store_code = decodeURIComponent(params.get('store_code') || '');
        const store_name = decodeURIComponent(params.get('store_name') || '');
        const is_history = decodeURIComponent(params.get('is_history') || '');
        this.get_filtered_beatpan_details_report(beatplan_date,aso_employeecode,store_code,is_history);
        this.setState({
            uid:this.props.match.params.id,
            beatplan_date:beatplan_date,
            aso_employeecode:aso_employeecode,
            store_code:store_code,
            store_name:store_name,
            is_history:is_history
            })
        //user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'live_transaction_dump_report','sparcs')

    }
     downLoadPkycDocBeatPlanDetailReport (e){
        let filters = {
            uid: this.state.uid,
            report_code:'beat_plan_report_details',
            beatplan_date: this.state.beatplan_date,
            aso_employeecode: this.state.aso_employeecode,
            store_code: this.state.store_code,
            is_history: this.state.is_history,
            download: 1
        }
        this.setState({
            filters:filters
        })

        const exportEndpoint = this.state.is_history === '1' ? 'aso_beatplan_utid_details_history' : 'aso_beatplan_utid_details';
        this.refs.downloadAllReport.downLoadReport(filters, '/sro_connectv4/' + exportEndpoint, 'aso_beatplan_utid_details_report', '');

    }

    get_filtered_beatpan_details_report(beatplan_date,aso_employeecode,store_code, is_history) {
        var that = this;
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);
        var postData = {
            beatplan_date: beatplan_date,
            aso_employeecode:aso_employeecode,
            store_code: store_code,
            is_history:is_history,
            report_code:'beat_plan_report_details'
        };
        if ($.fn.DataTable.isDataTable('#BeatPlanDetailReportTable')) {
            $('#BeatPlanDetailReportTable').DataTable().clear().destroy();
        }

        BeatPlanDetailReportTable = $('#BeatPlanDetailReportTable').DataTable(
            {
                order:[],
                //"dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": true,
                "responsive": false,
                "searching": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],

                ajax: {
                    url:config.get('API_URL')+ "/InternalReport/aso_beatplan_utid_details",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true)
                        console.log("complete", data);
                    },
                },
                columns:[
                    { "data": "ticket_id" },
                    { "data": "cf_utid" },
                    { "data": "cf_issue_sub_category" },
                    { "data": "ticket_type" },
                    { "data": "utid_ticket_status" },
                    // AI QC Status - handle null/undefined
                    {
                        "data": "qcstatus",
                        "render": function(data) {
                            return data || "";
                        }
                    },
                    // AI QC Status Details - shows only + icon when collapsed (index 6)
                    {
                        "data": "reasondetailed",
                        "render": function(data) {
                            // Only show + icon if data exists, otherwise show blank
                            if (!data || data === 'null' || data === null) return "";
                            return "<div style='text-align: center;'><i class='fa fa-plus-circle ai-qc-toggle' style='cursor:pointer; color:#4b3092; font-size:16px;'></i></div>";
                        }
                    },
                    // Jobsheet Reason (index 7)
                    {
                        "data": "reasondetailed",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                return (parsed.jobsheet && parsed.jobsheet.reasons) || '-';
                            } catch(e) { return "-"; }
                        }
                    },
                    // Jobsheet Status (index 8)
                    {
                        "data": "reasondetailed",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                return (parsed.jobsheet && parsed.jobsheet.status) || '-';
                            } catch(e) { return "-"; }
                        }
                    },
                    // Store Photo Reason
                    {
                        "data": "reasondetailed",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                return (parsed.store_photo && parsed.store_photo.reasons) || '-';
                            } catch(e) { return "-"; }
                        }
                    },
                    // Store Photo Status
                    {
                        "data": "reasondetailed",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                return (parsed.store_photo && parsed.store_photo.status) || '-';
                            } catch(e) { return "-"; }
                        }
                    },
                    // Store Selfie Reason
                    {
                        "data": "reasondetailed",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                return (parsed.store_selfie && parsed.store_selfie.reasons) || '-';
                            } catch(e) { return "-"; }
                        }
                    },
                    // Store Selfie Status
                    {
                        "data": "reasondetailed",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                return (parsed.store_selfie && parsed.store_selfie.status) || '-';
                            } catch(e) { return "-"; }
                        }
                    },
                    // Product Sticker Reason
                    {
                        "data": "reasondetailed",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                return (parsed.product_sticker && parsed.product_sticker.reasons) || '-';
                            } catch(e) { return "-"; }
                        }
                    },
                    // Product Sticker Status
                    {
                        "data": "reasondetailed",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                return (parsed.product_sticker && parsed.product_sticker.status) || '-';
                            } catch(e) { return "-"; }
                        }
                    },
                    // Churned Terminal Reason
                    {
                        "data": "reasondetailed",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                return (parsed.churned_terminal && parsed.churned_terminal.reasons) || '-';
                            } catch(e) { return "-"; }
                        }
                    },
                    // Churned Terminal Status
                    {
                        "data": "reasondetailed",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                return (parsed.churned_terminal && parsed.churned_terminal.status) || '-';
                            } catch(e) { return "-"; }
                        }
                    },
                    // Churned Accessories Reason
                    {
                        "data": "reasondetailed",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                return (parsed.churned_accessories && parsed.churned_accessories.reasons) || '-';
                            } catch(e) { return "-"; }
                        }
                    },
                    // Churned Accessories Status
                    {
                        "data": "reasondetailed",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                return (parsed.churned_accessories && parsed.churned_accessories.status) || '-';
                            } catch(e) { return "-"; }
                        }
                    },
                    // Cable & Attachment Reason
                    {
                        "data": "reasondetailed",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                return (parsed.cable_and_attachment && parsed.cable_and_attachment.reasons) || '-';
                            } catch(e) { return "-"; }
                        }
                    },
                    // Cable & Attachment Status
                    {
                        "data": "reasondetailed",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                return (parsed.cable_and_attachment && parsed.cable_and_attachment.status) || '-';
                            } catch(e) { return "-"; }
                        }
                    },
                    { "data": "test_txn_status" },
                    { "data": "txn_mode" },
                    { "data": "software_version" },
                    { "data": "upgrade_software_version" },
                    { "data": "test_txn_timestamp" },
                    { "data": "transactionslip_status" },
                    { "data": "transactionslip_url" },
                    { "data": "transactionslip_upload_timestamp" },
                    { "data": "productstickerimage_status" },
                    { "data": "productstickerimage_url" },
                    { "data": "productstickerimage_upload_timestamp" },
                    { "data": "serialnumberimage_status" },
                    { "data": "serialnumberimage_url" },
                    { "data": "serialnumberimage_upload_timestamp" },
                    { "data": "oldserialnumberimage_status" },
                    { "data": "oldserialnumberimage_url" },
                    { "data": "oldserialnumberimage_upload_timestamp" },
                    { "data": "churnterminalimage_status" },
                    { "data": "churnterminalimage_url" },
                    { "data": "churnterminalimage_upload_timestamp" },
                    { "data": "churnaccessoriesimage_status" },
                    { "data": "churnaccessoriesimage_url" },
                    { "data": "churnaccessoriesimage_upload_timestamp" },
                    { "data": "terminalmissing_status" },
                    { "data": "terminalmissing_url" },
                    { "data": "terminalmissing_upload_timestamp" },
                    { "data": "adapter" },
                    { "data": "cable" },
                    { "data": "base_station" },
                    { "data": "stand" },
                    { "data": "brandcablephoto_status" },
                    { "data": "brandcablephoto_url" },
                    { "data": "brandcablephoto_upload_timestamp" },
                    { "data": "jobsheet_status" },
                    { "data": "jobsheet_url" },
                    { "data": "store_photo_url"},
                    { "data": "store_selfie_url"},
                    { "data": "visit_started_at"},
                    { "data": "jobsheet_upload_timestamp" },
                    // Action Lists - shows only + icon when collapsed (index 55)
                    {
                        "data": "action_lists",
                        "render": function(data) {
                            if (!data || data === 'null' || data === null) return "";
                            return "<div style='text-align: center;'><i class='fa fa-plus-circle action-list-toggle' style='cursor:pointer; color:#4b3092; font-size:16px;'></i></div>";
                        }
                    },
                    // Replaced Cable (index 56)
                    {
                        "data": "action_lists",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                const key = Object.keys(parsed).find(k => k.trim() === "Replaced Cable");
                                return key !== undefined && parsed[key] ? "Yes" : "No";
                            } catch(e) { return "-"; }
                        }
                    },
                    // Replaced Adaptor (index 57)
                    {
                        "data": "action_lists",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                const key = Object.keys(parsed).find(k => k.trim() === "Replaced Adaptor");
                                return key !== undefined && parsed[key] ? "Yes" : "No";
                            } catch(e) { return "-"; }
                        }
                    },
                    // Replaced SIM Card (index 58)
                    {
                        "data": "action_lists",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                const key = Object.keys(parsed).find(k => k.trim() === "Replaced SIM Card");
                                return key !== undefined && parsed[key] ? "Yes" : "No";
                            } catch(e) { return "-"; }
                        }
                    },
                    // Replaced Terminal (index 59)
                    {
                        "data": "action_lists",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                const key = Object.keys(parsed).find(k => k.trim() === "Replaced Terminal");
                                return key !== undefined && parsed[key] ? "Yes" : "No";
                            } catch(e) { return "-"; }
                        }
                    },
                    // Software Reinstalled (index 60)
                    {
                        "data": "action_lists",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                const key = Object.keys(parsed).find(k => k.trim() === "Software reinstalled");
                                return key !== undefined && parsed[key] ? "Yes" : "No";
                            } catch(e) { return "-"; }
                        }
                    },
                    // Replaced Base Station (index 61)
                    {
                        "data": "action_lists",
                        "render": function(data) {
                            if (!data) return "-";
                            try {
                                const parsed = typeof data === 'string' ? JSON.parse(data) : data;
                                const key = Object.keys(parsed).find(k => k.trim() === "Replaced Base Station");
                                return key !== undefined && parsed[key] ? "Yes" : "No";
                            } catch(e) { return "-"; }
                        }
                    },
                    // ASO Comments (index 62)
                    {
                        "data": "asocomments",
                        "render": function(data) {
                            return data || "";
                        }
                    },
                    // ---- v4 (new app) columns: index 68 onwards. v3 rows me blank ----
                    { "data": "app_version", "defaultContent": "" },
                    { "data": "serial_no", "defaultContent": "" },
                    { "data": "expected_serial_no", "defaultContent": "" },
                    { "data": "dll_version", "defaultContent": "" },
                    { "data": "expected_dll_version", "defaultContent": "" },
                    { "data": "terminal_missing_exception_id", "defaultContent": "" },
                    { "data": "terminal_missing_exception_status", "defaultContent": "" },
                    ...['newterminalphoto','frontproductsticker','backproductsticker','topproductsticker','bottomproductsticker','leftproductsticker','rightproductsticker','connectorphoto']
                      .flatMap(n => [
                          { "data": n + "_status", "defaultContent": "" },
                          { "data": n + "_url", "defaultContent": "" },
                          { "data": n + "_upload_timestamp", "defaultContent": "" }
                      ]),
                    { "data": "sim_card", "defaultContent": "" },
                    { "data": "terminal", "defaultContent": "" },
                    { "data": "device_available", "defaultContent": "" },
                    ],
                 "columnDefs": [

                  {
                        "targets": 4,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {//console.log(rowData.Status);
                        //console.log(td);
                            if (rowData.utid_ticket_status == 'Complete') {
                                $(td).addClass('doneLog');
                            }

                            else if (rowData.visit_status == 'NotStarted') {
                                $(td).addClass('failedLog');
                            }
                            else {
                                $(td).addClass('ongoingLog');
                            }
                        },
                    },
                {
                    "width": "50px",
                     "className":"text-center",
                    "targets": [27,30,33,36,39,42,45,52,55,56,57,58],
                    "data": "data",
                    "createdCell": (td, cellData, rowData, row, col) => {
                    $(td).text('');

                    // Map column index to its respective URL field
                    const urlFieldMap = {
                        27: 'transactionslip_url',
                        30: 'productstickerimage_url',
                        33: 'serialnumberimage_url',
                        36: 'oldserialnumberimage_url',
                        39: 'churnterminalimage_url',
                        42: 'churnaccessoriesimage_url',
                        43: 'terminalmissing_url',
                        52: 'brandcablephoto_url',
                        55: 'jobsheet_url',
                        56: 'store_photo_url',
                        57: 'store_selfie_url',
                        58: 'store_selfie_url'
                    };

                    const field = urlFieldMap[col];

                    if (rowData[field]) {
                        $(td).append('<a href="#" data-tip="View" title="Download" id="Download" class="RerunButton"><i class="fa fa-download"></i></a>');
                        $(td).click(e => {
                            this.download_doc(e, rowData[field]);
                        });
                    } else {
                        $(td).append('');
                    }


                    },
                    bSortable: false,
                },
                 {
                    render: function (data) {
                        if (data == '' || data == null || data == 'null') {
                            return "";
                        } else {
                            return "<div class='text-wrap width-80'>" + moment(data).format('D MMM YYYY HH:mm:ss') + "</div>";
                        }
                    },
                    "width": "80px",
                    "targets": [25,28,31,34,37,40,43,46,53,58,59]
                },
                // ASO Comments hover popup
                {
                    "targets": 67, // asocomments column
                    "width": "120px", // Fixed column width
                    "createdCell": (td, cellData, rowData, row, col) => {
                        // Apply fixed width and text truncation to the cell
                        $(td).css({
                            'max-width': '120px',
                            'overflow': 'hidden',
                            'text-overflow': 'ellipsis',
                            'white-space': 'nowrap'
                        });

                        if (cellData && cellData !== '' && cellData !== 'null') {
                            $(td).addClass('aso-comment-cell');
                            $(td).css('cursor', 'pointer');

                            $(td).on('mouseenter', function(e) {
                                // Remove any existing popup
                                $('.aso-comment-popup').remove();

                                // Create popup with FIXED dimensions
                                const popup = $(`
                                    <div class="aso-comment-popup" style="
                                        position: fixed;
                                        z-index: 9999;
                                        background: white;
                                        border: 2px solid #4b3092;
                                        border-radius: 8px;
                                        padding: 15px;
                                        width: 350px;
                                        max-width: 350px;
                                        min-width: 350px;
                                        box-shadow: 0 4px 20px rgba(0,0,0,0.3);
                                        font-size: 14px;
                                        line-height: 1.5;
                                        color: #333;
                                        user-select: text;
                                    ">
                                        <div style="font-weight: bold; margin-bottom: 8px; color: #4b3092; border-bottom: 1px solid #ddd; padding-bottom: 5px;">
                                            ASO Comments
                                        </div>
                                        <div style=" overflow-y: auto; word-wrap: break-word; word-break: break-all;">
                                            ${cellData}
                                        </div>
                                    </div>
                                `);

                                $('body').append(popup);

                                // Get the ASO Comments header position for consistent placement
                                const headerCell = $('#BeatPlanDetailReportTable thead th.aso-comments-th');
                                const headerRect = headerCell.length ? headerCell[0].getBoundingClientRect() : null;
                                const cellRect = td.getBoundingClientRect();

                                // Position popup below header, right-aligned
                                let top = headerRect ? headerRect.bottom + 5 : cellRect.bottom + 5;
                                let left = headerRect ? headerRect.right - 350 : cellRect.right - 350;

                                // Ensure popup stays within viewport
                                if (left < 10) {
                                    left = 10;
                                }
                                if (top + 200 > window.innerHeight) {
                                    top = window.innerHeight - 210;
                                }

                                popup.css({ top: top + 'px', left: left + 'px' });
                            });

                            $(td).on('mouseleave', function(e) {
                                // Small delay to allow mouse to move to popup
                                setTimeout(() => {
                                    if (!$('.aso-comment-popup:hover').length) {
                                        $('.aso-comment-popup').remove();
                                    }
                                }, 100);
                            });
                        }
                    }
                },
                // v4 photo URL columns: download icon
                {
                    "targets": [76,79,82,85,88,91,94,97],
                    "width": "50px",
                    "className": "text-center",
                    "bSortable": false,
                    "createdCell": (td, cellData) => {
                        $(td).text('');
                        if (cellData) {
                            $(td).append('<a href="#" data-tip="View" title="Download" class="RerunButton"><i class="fa fa-download"></i></a>');
                            $(td).click(e => {
                                this.download_doc(e, cellData);
                            });
                        }
                    }
                },
                // v4 photo timestamp columns: date format
                {
                    "targets": [77,80,83,86,89,92,95,98],
                    "width": "80px",
                    "render": function (data) {
                        if (data == '' || data == null || data == 'null') {
                            return "";
                        }
                        return "<div class='text-wrap width-80'>" + moment(data).format('D MMM YYYY HH:mm:ss') + "</div>";
                    }
                }
               ],
               "initComplete": (settings, json) => {
                   this.updateColumnVisibility();
                   $('#BeatPlanDetailReportTable').on('click', '.ai-qc-toggle', (e) => {
                       e.stopPropagation();
                       this.toggleAiQcDetail();
                   });
                   $('#BeatPlanDetailReportTable').on('click', '.action-list-toggle', (e) => {
                       e.stopPropagation();
                       this.toggleActionList();
                   });

                   $(document).on('mouseleave', '.aso-comment-popup', function() {
                       $(this).remove();
                   });
               }
            });


    }
    download_doc(e, rowData){


    axios.post(config.get('API_URL') + '/InternalReport/download-beatplan-image/',
        {
           file_path:rowData
        },
        {
            headers: {
                Authorization: `${localStorage.usertoken}`
            }
        }
    ).then(response => {
        console.log(response.data)
        if (response.data.error && response.data.error.trim() !== "") {
          alert(response.data.error);
        }
        const downloadLink = response.data.data;// Make sure your backend sends the link like { link: "https://..." }

        if (downloadLink) {
            const a = document.createElement('a');
            a.href = downloadLink;
            a.download = ''; // optional: set filename if you want
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } else {
            console.error("No download link in response.");
        }
    }).catch(error => {
        console.error("Download error:", error);
    });


    }
    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
//         if(this.state.object_type==='Innoviti')
//         {
//
//             this.refs.reloadUtid.ci_utid('','','',false,'');
//         }
        this.refs.asoNameFilter.restAsoFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            aso_names:'',
            ciutidIds: '',
            isChange: false

        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
    }
    handleAsoEvents = (optionSelected, event_names) =>
    {
        this.setState({
            aso_names:event_names,
            isChange: true
        });
    }
    goBack = () => {
        this.props.history.push('/admin/beat-plan-report')
    }

    render() {
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">{this.state.store_name} - ({this.state.store_code})</h4>
                                        <p className="category"><b>ASO Employee Code - {this.state.aso_employeecode}, Beat plan Date - {this.state.beatplan_date}</b></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                       <button type="button" className="primary reset-filter" role="button"  onClick={this.goBack}><i class="fa fa-arrow-circle-left"></i>Back</button>

                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
{/*                                     <div className="row"> */}
{/*                                         <div className="col-md-12"> */}
{/*                                             <div className="col-md-2 filter-bottom5 padd-5 date-icon-small"> */}
{/*                                                 <div><label>Date Filter: </label></div> */}
{/*                                                 <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow} */}
{/*                                                 start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/> */}
{/*                                             </div> */}
{/*                                             <div className="col-md-3 filter-bottom5 padd-5"> */}
{/*                                                 <label> ASO Name </label> */}
{/*                                                 <AsoMultiFilter ref="asoNameFilter" onSelectaso = {this.handleAsoEvents} /> */}
{/*                                                 <div className="clearfix"></div> */}
{/*                                             </div> */}
{/*                                              */}
{/*                                         </div> */}

{/*                                     </div> */}
{/*                                     <div className="row"> */}
{/*                                         <div className="col-md-5 pull-right"> */}
{/*                                             {this.state.isChange===true? */}
{/*                                                 <span className="apply-notification">Please click on Apply button</span>:null */}
{/*                                             } */}
{/*                                             <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_beatpan_details_report.bind(this)}>Apply</button> */}
{/*                                             <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button> */}
{/*                                         </div> */}
{/*                                     </div> */}


                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>

                                    <div className="">
                                        <a href="#" className="exportButton1" role="button" onClick={this.downLoadPkycDocBeatPlanDetailReport.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>

                                    <div className="content-tdetails-table table-full-width marginTop0">
                                        <table id="BeatPlanDetailReportTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th rowSpan="3">Ticket ID</th>
                                                <th rowSpan="3">UTID</th>
                                                <th rowSpan="3">Issue Sub Category</th>
                                                <th rowSpan="3">Ticket Type</th>
                                                <th rowSpan="3">UTID Ticket Status</th>
                                                <th rowSpan="3">AI QC Status</th>
                                                <th
                                                    colSpan="15"
                                                    style={{textAlign: 'center', color: 'white', cursor: this.state.isAiQcExpanded ? 'pointer' : 'default'}}
                                                    onClick={this.state.isAiQcExpanded ? this.toggleAiQcDetail : null}
                                                >
                                                    AI QC Status Details {this.state.isAiQcExpanded && <i className="fa fa-minus-circle" style={{marginLeft: '5px'}}></i>}
                                                </th>
                                                <th rowSpan="3">Test Txn Status</th>
                                                <th rowSpan="3">Txn Mode</th>
                                                <th rowSpan="3">Software Version</th>
                                                <th rowSpan="3">Upgrade Software Version</th>
                                                <th rowSpan="3">Test Txn Timestamp</th>
                                                <th rowSpan="3">Transaction Slip Image Status</th>
                                                <th rowSpan="3">Transaction Slip Image</th>
                                                <th rowSpan="3">Transaction Slip Upload Timestamp</th>
                                                <th rowSpan="3">Product Sticker Image Status</th>
                                                <th rowSpan="3">Product Sticker Image </th>
                                                <th rowSpan="3">Product Sticker Image Upload Timestamp</th>
                                                <th rowSpan="3">Serial Number Image Status</th>
                                                <th rowSpan="3">Serial Number Image </th>
                                                <th rowSpan="3">Serial Number Image Upload Timestamp</th>
                                                <th rowSpan="3">Old Serial Number Image Status</th>
                                                <th rowSpan="3">Old Serial Number Image </th>
                                                <th rowSpan="3">Old Serial Number Image Upload Timestamp</th>
                                                <th rowSpan="3">Churn Terminal Image Status</th>
                                                <th rowSpan="3">Churn Terminal Image </th>
                                                <th rowSpan="3">Churn Terminal Image Upload Timestamp</th>
                                                <th rowSpan="3">Churn Accessories Image Status</th>
                                                <th rowSpan="3">Churn Accessories Image </th>
                                                <th rowSpan="3">Churn Accessories Image Upload Timestamp</th>
                                                <th rowSpan="3">Terminal Missing Status</th>
                                                <th rowSpan="3">Terminal Missing </th>
                                                <th rowSpan="3">Terminal Missing Upload Timestamp</th>
                                                <th rowSpan="3">Adapter</th>
                                                <th rowSpan="3">Cable</th>
                                                <th rowSpan="3">Base Station</th>
                                                <th rowSpan="3">Stand</th>
                                                <th rowSpan="3">Branded Cable Status</th>
                                                <th rowSpan="3">Branded Cable URL</th>
                                                <th rowSpan="3">Branded Cable Timestamp</th>
                                                <th rowSpan="3">Job Sheet Status</th>
                                                <th rowSpan="3">Job Sheet URL</th>
                                                <th rowSpan="3">Store Photo URL</th>
                                                <th rowSpan="3">Store Selfie URL</th>
                                                <th rowSpan="3">Visit Started At</th>
                                                <th rowSpan="3">Job Sheet Upload Timestamp</th>
                                                <th
                                                    colSpan="7"
                                                    style={{textAlign: 'center', color: 'white', cursor: this.state.isActionListExpanded ? 'pointer' : 'default'}}
                                                    onClick={this.state.isActionListExpanded ? this.toggleActionList : null}
                                                >
                                                    Action Lists {this.state.isActionListExpanded && <i className="fa fa-minus-circle" style={{marginLeft: '5px'}}></i>}
                                                </th>
                                                <th rowSpan="3" className="aso-comments-th">Aso Comments</th>
                                                <th rowSpan="3">App Version</th>
                                                <th rowSpan="3">Serial No</th>
                                                <th rowSpan="3">Expected Serial No</th>
                                                <th rowSpan="3">DLL Version</th>
                                                <th rowSpan="3">Expected DLL Version</th>
                                                <th rowSpan="3">Terminal Missing Exception ID</th>
                                                <th rowSpan="3">Terminal Missing Exception Status</th>
                                                {['New Terminal Photo','Front Product Sticker','Back Product Sticker','Top Product Sticker','Bottom Product Sticker','Left Product Sticker','Right Product Sticker','Connector Photo'].flatMap(h => [
                                                    <th key={h+'-s'} rowSpan="3">{h} Status</th>,
                                                    <th key={h+'-u'} rowSpan="3">{h}</th>,
                                                    <th key={h+'-t'} rowSpan="3">{h} Upload Timestamp</th>
                                                ])}
                                                <th rowSpan="3">SIM Card</th>
                                                <th rowSpan="3">Terminal</th>
                                                <th rowSpan="3">Device Available</th>
                                             </tr>
                                             <tr>
                                                 <th rowSpan="2" style={{textAlign: 'center'}}></th>
                                                 <th colSpan="2" style={{textAlign: 'center'}}>Jobsheet</th>
                                                 <th colSpan="2" style={{textAlign: 'center'}}>Store Photo</th>
                                                 <th colSpan="2" style={{textAlign: 'center'}}>Store Selfie</th>
                                                 <th colSpan="2" style={{textAlign: 'center'}}>Product Sticker</th>
                                                 <th colSpan="2" style={{textAlign: 'center'}}>Churned Terminal</th>
                                                 <th colSpan="2" style={{textAlign: 'center'}}>Churned Accessories</th>
                                                 <th colSpan="2" style={{textAlign: 'center'}}>Cable & Attachment</th>
                                                 <th rowSpan="2" style={{textAlign: 'center'}}></th>
                                                 <th rowSpan="2" style={{textAlign: 'center'}}>Replaced Cable</th>
                                                 <th rowSpan="2" style={{textAlign: 'center'}}>Replaced Adaptor</th>
                                                 <th rowSpan="2" style={{textAlign: 'center'}}>Replaced SIM Card</th>
                                                 <th rowSpan="2" style={{textAlign: 'center'}}>Replaced Terminal</th>
                                                 <th rowSpan="2" style={{textAlign: 'center'}}>Software Reinstalled</th>
                                                 <th rowSpan="2" style={{textAlign: 'center'}}>Replaced Base Station</th>
                                             </tr>
                                             <tr>
                                                 <th>Reason</th>
                                                 <th>Status</th>
                                                 <th>Reason</th>
                                                 <th>Status</th>
                                                 <th>Reason</th>
                                                 <th>Status</th>
                                                 <th>Reason</th>
                                                 <th>Status</th>
                                                 <th>Reason</th>
                                                 <th>Status</th>
                                                 <th>Reason</th>
                                                 <th>Status</th>
                                                 <th>Reason</th>
                                                 <th>Status</th>
                                             </tr>
                                             </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <MultiCsvReportDownload ref="downloadAllReport" />

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
        currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
}
export default connect(null,mapDispatchToProps)(BeatPlanDetailReport)